namespace Gamification.Gamification {

    Serenity.Decorators.registerClass()
    export class NodiEditorDialog extends Serenity.Extensions.GridEditorDialog<NodiRow> {
        protected getFormKey() { return NodiForm.formKey; }
        protected getLocalTextPrefix() { return NodiRow.localTextPrefix; }
        protected getNameProperty() { return NodiRow.nameProperty; }

        protected form = new NodiForm(this.idPrefix);

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            //opt.title = "API Script utente";
            opt.height = 600;
            opt.width = 800;
            return opt;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew()) {
                if (this.idChecklist > 0) {
                    this.form.IdChecklist.value = this.idChecklist.toString();
                    Serenity.EditorUtils.setReadOnly(this.form.IdChecklist, true);
                }
            }
        }

        // /////////////////////////////////
        private _idChecklist: number;

        get idChecklist() {
            return this._idChecklist;
        }

        set idChecklist(value: number) {
            if (this._idChecklist != value) {
                this._idChecklist = value;
            }
        }
    }
}
